"use strict";

module.exports = function (value) {
  // eslint-disable-next-line no-self-compare
  return value !== value;
};